import { extractPathIdentifier } from './api-helpers';
import { COMMON_PAGE_PATHS } from '../../constans/url-constants';
import { authService } from '../services/auth-service';


/* eslint-disable-next-line @typescript-eslint/ban-types */
export const proxyObjectWrapper = <T>(targetObject: T, handler: ProxyHandler<Object>): T => {
  const proxyfiedObject = { ...targetObject };
  for (const key in targetObject) {
    if (typeof targetObject[key] === 'function') {
      Object.defineProperty(proxyfiedObject, key, {
        value: new Proxy(targetObject[key] as Function, handler)
      });
    }
  }
  return proxyfiedObject;
};

export const compileAuthProxyHandler = (apiBasePath: string): ProxyHandler<typeof Function> => {
  return {
    apply: function (target, _this, args) {
      const presentationEmbedId: string = extractPathIdentifier(COMMON_PAGE_PATHS.PRESENTATION);
      const jwtAuthToken = authService.getJwtToken(presentationEmbedId) || '';
      const [path, body = {}, config = {}] = args;

      const newPath = `${apiBasePath}/${path}`;

      const authHeaders = {
        'X-Presenter-Authentication': jwtAuthToken
      };
      const configToSend = { ...config, headers: authHeaders };
      return target(newPath, body, configToSend);
    }
  };
};

export const compileDefaultProxyHandler = (apiBasePath: string): ProxyHandler<typeof Function> => {
  return {
    apply: function (target, _this, args) {
      const [path, body = {}, config = {}] = args;
      const newPath = `${apiBasePath}/${path}`;
      return target(newPath, body, config);
    }
  };
};
